<!--
 * @Author: your name
 * @Date: 2020-07-29 16:08:35
 * @LastEditTime: 2020-08-12 10:29:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\userAgreement\userAgreement.vue
-->
<template>
	<div class="userAgreement-wrap">
		<div class="userAgreement-content">
			<div class="userAgreement-back"></div>
			<div class="userAgreement-text">
				<div class="userAgreement-text-box">
					<div style="text-align: center;font-size:0.18rem; font-weight: bold;margin-bottom:0.2rem;opacity:1;color:#333333">投保须知</div>
					<div class="userAgreement-text-content">
						<div>产品介绍</div>
						<div>
							<span style="margin-left: 0.32rem;"></span> 本保险保障取暖用户住房内部暖气管道（含暖气片）突然破裂致使水流外溢（事故发生时破损的水暖组件不在赔偿范围内），造成被保险人或第三方房屋内财产的直接损失，其他事故造成被保险人或第三方财产损失，保险人不承担保险责任。
            </div>
            <div>产品详情</div>
            <div>
              <span style="margin-left: 0.32rem;"></span>1、保障期间：1年
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>2、限购份数：1份
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>3、适用人群：本产品仅承保建筑结构为钢筋混凝土或砖石混凝土结构且不用于生产经营的居民住宅，其他结构房屋或用于从事工商业生产、经营活动的财产和出租用作工商业的房屋，保险人不承担保险责任。
            </div>
            <div>保险责任</div>
            <div>
              <span style="margin-left: 0.32rem;"></span>1、本保险适用保险条款名称为《家庭财产综合保险条款（2009版）》及所投保的相应附加险保险条款；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>2、本产品保险合同中《附加管道破裂及水渍保险条款》及《附加第三者责任保险条款》仅承保被保险人在本合同列明的住房内部暖气管道（含暖气片）突然破裂致使水流外溢（事故发生时破损的水暖组件不在赔偿范围内），造成被保险人或第三方房屋内财产的直接损失，其他事故造成被保险人或第三方财产损失，保险人不承担保险责任；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>3、本产品《附加管道破裂及水渍保险条款》中因被保险人在合同列明的住房内部暖气管道（含暖气片）突然破裂致使水流外溢，造成被保险人房屋内财产直接损失保险金额9000元，其中室内装潢保险金额5000元，室内财产保险金额4000元；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>4、本产品《附加第三者责任保险条款》中因被保险人在合同列明的住房内部暖气管道（含暖气片）突然破裂致使水流外溢，造成第三方房屋内财产直接损失保险金额9000元，其中室内装潢保险金额5000元，室内财产保险金额4000元；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>5、每个家庭地址限购1份，多出部分无效；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>6、c
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>7、出险后需提供供热公司出具的原因证明。
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>8、主险室内财产每次事故免赔额为损失金额的80%。
            </div>
            
            <div>理赔告知</div>
            <div>下列原因造成的损失，中华联合保险公司不承担赔偿责任:</div>
            <div>
              <span style="margin-left: 0.32rem;"></span>1、被保险房屋内的暖气管道（含暖气片）年久失修、自然老化、腐蚀严重（例如阀门控制失灵、管道、管件（含跑风）滴水、渗水没有及时维护维修等）。
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>2、被保险人的故意行为（例如擅自改动室内外供热设施，擅自开启供热阀门、擅自安装放水阀、循环泵等）。
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>3、装修改造施工过程中致使暖气管道破裂。
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>4、因用户对暖气管道（含暖气片）安装、试水、试压造成的破裂跑水（供热公司试水期以供热公司公告为准）。
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>5、在暖气管道（含暖气片）保质期内，应由保修或销售单位承担更换费用以及其应承担赔偿责任的其他财产损失，保险人也不负责赔偿。
            </div>
            <div>下列家庭财产不属于本保险合同的保险标的：</div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（一）金银、珠宝、钻石及制品，玉器、首饰、古币、古玩、字画、邮票、艺术品、稀有金属等珍贵财物；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（二）货币、票证、有价证券、文件、书籍、账册、图表、技术资料、电脑软件及资料、以及无法鉴定价值的财产；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（三）日用消耗品、各种交通工具、养殖及种植物；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（四）用于从事工商业生产、经营活动的财产和出租用作工商业的房屋；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（五）无线通讯工具、笔、打火机、手表，各种磁带、磁盘、影音激光盘；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（六）用芦席、稻草、油毛毡、麦秸秆、芦苇、竹竿、帆布、塑料布、纸板等为外墙、屋顶的简陋屋棚及柴房、禽畜棚、与保险房屋不成一体的厕所、围墙、无人居住的房屋以及存放在里面的财产；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（七）政府有关部门征用、占用的房屋，违章建筑、危险建筑、非法占用的财产、处于危险状态下的财产。
            </div>
            <div>责任免除</div>
            <div>由于下列原因造成保险标的的损失、费用，保险人不负责赔偿：</div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（一）战争、敌对行为、军事行动、武装冲突、罢工、暴动、骚乱、政变、谋反、恐怖活动、盗抢；
            </div>
            <div>
              <span style="margin-left: 0.32rem;"></span>（二）核反应、核子辐射和其他放射性污染；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（三）被保险人及其家庭成员、寄居人、雇佣人员的重大过失、违法、犯罪或故意行为。
            </div>
            <div>保险人对下列损失和费用，也不负责赔偿：</div>
            <div>
            <span style="margin-left: 0.32rem;"></span>(一）保险标的遭受保险事故引起的各种间接损失；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（二）地震及其次生灾害、海啸及其次生灾害造成的损失；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（三）家用电器因使用过度、超电压、短路、断路、漏电、自身发热、烘烤等原因所造成本身的损毁；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（四）坐落在蓄洪区、行洪区，或在江河岸边、低洼地区以及防洪堤以外当地常年警戒水位线以下的家庭财产，由于洪水所造成的一切损失；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（五）保险标的本身缺陷、保管不善导致的损毁；保险标的变质、腐烂、受潮、虫咬、自然磨损、自然损耗、自燃、烘焙所造成本身的损失；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（六）行政、司法行为引起的损失和费用；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（七）本保险合同中载明的免赔额或按本保险合同中载明的免赔率计算的免赔金额；
            </div>
            <div>
            <span style="margin-left: 0.32rem;"></span>（八）其他不属于保险责任范围内的损失和费用。
            </div>
          </div>
          <div class="userAgreement-check">
            <span v-if="checkedFlag" @click="checkedFlag = false">
              <img
                src="../../assets/image/selected-icon.png"
                style="width: 0.16rem;height:0.16rem;margin-top:0.03rem"
                alt
              />
            </span>
            <span v-else @click="checkedFlag = true">
              <img
                src="../../assets/image/outcheck-icon.png"
                alt
                style="width: 0.16rem;height:0.16rem;margin-top:0.03rem"
              />
            </span>
            <span
              :class="checkedFlag ? 'userAgreement-outcheck-text' : 'userAgreement-check-text'"
            >投保人声明：本人已经仔细阅读保险条款，尤其是字体加粗部分的条款内容，并对保险公司就保险条款内容的说明和提示完全理解，没有异议，申请投保。</span>
          </div>
        </div>
      </div>

      <div :class="checkedFlag ? 'userAgreement-btn-check' : 'userAgreement-btn'">
        <el-button type="primary" :disabled="enterDisabled" @click="gotoPayMent">继续缴费</el-button>
      </div>
      <div class="userAgreement-btn">
        <el-button
          type="primary"
          style="background:rgba(0,123,131,0.1);border:1px solid rgba(0,123,131,1);color:#007B83;opacity:1"
          @click="exitPayMent"
        >取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userAgreement',
  data() {
    return {
      phone: '',
      cardCode: '',// 卡号
      areaCost: '',// 供暖费
      houseInfo: '',
      insuranceMoney: '',
      checkedFlag: false,
      payFlag: true,// true为供暖  false为跑漏险
      payData: {},// 缴费参数信息
      enterDisabled:false
    }
  },
  methods: {

    // 供暖缴费
    async payHeating() {
       this.enterDisabled=true;
       const payRes = await this.$http.post(
         `${this.$url.globalurl}/placeOrder/`, this.payData);
       WeixinJSBridge.invoke("getBrandWCPayRequest", payRes.result, res => {
         if (res.err_msg == "get_brand_wcpay_request:ok") {
          this.$router.replace({
            name: "paySucceed",
            query: {
              areaCost: this.areaCost,
              insuranceMoney: this.insuranceMoney,
              houseInfo: this.houseInfo,
              payFlag: this.payFlag
            }
          });
         }
         this.enterDisabled=false;
       });


    },
    // 跑漏险缴费
    async payInsurance() {
      this.enterDisabled=true;
       const payRes = await this.$http.post(`${this.$url.globalurl}/placeOrder/`, this.payData);
       WeixinJSBridge.invoke("getBrandWCPayRequest", payRes.result, res => {
         if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.replace({
              name: "insuranceSucceed",
              query: {
                insuranceMoney: this.insuranceMoney,
                houseInfo: this.houseInfo,
                areaCost: this.areaCost,
              }
            });
         }
         this.enterDisabled=false;
       });
    },
    // 跳转到对应的缴费成功页面
    gotoPayMent() {
      if (!this.checkedFlag) return;
      if (this.payFlag) {
        this.payHeating();
      } else {
        this.payInsurance();
      }
    },
    exitPayMent() {
      this.$router.replace({
        name: 'index'
      })
    }
  },
  mounted() {
    if (this.$route.query) {
      this.insuranceMoney = this.$route.query.insuranceMoney;
      this.houseInfo = this.$route.query.houseInfo;
      this.payFlag = this.$route.query.payFlag;
      this.payData = this.$route.query.payData;
      this.areaCost = this.$route.query.areaCost;
    }
    document.title = '投保须知';
  }
}
</script>
<style lang='scss' scoped>
@import url(userAgreement.scss);
</style>